<template>
  <div class="home">
    <div class="header">
    <h1>成品油数据可视化系统</h1>
  </div>
  <div class="wraper">
    <!-- main-left -->
    <div class="main-left">
      <!-- 原油变化率 -->
      <div class="chart-box">
        <div class="yuanyoubianhualv">
          <div class="box" v-for="(item,index) in YYBHLPrice" :key="index">
            <div class="title">{{ item.title }}</div>
            <div class="text">
              <strong>{{ item.value }}</strong>
              <span :class="comZhangDie(item)">
                <i class="icon"></i>
                <em>{{item.floatValue}}</em>
                <em style="margin-left:.1rem;">{{item.floatRate===0?'-':item.floatRate+'%'}}</em>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div style="flex:2;">
        <div class="yybhl-bottom" style="height:100%; display:flex; flex-direction:column;">
          <h3 class="title">原油变化率</h3>
          <div class="text" style="flex:1; display:flex; align-items:center;">
            <ul class="ulist" style="flex:1.1;">
              <li><span class="label">变化率</span><span class="num">{{yuanYouBianHuaLv.price}}%</span></li>
              <li><span class="label">涨跌</span><span class="num">{{yuanYouBianHuaLv.upsAndDowns}}<i class="icon" :class="comZd(yuanYouBianHuaLv.upsAndDowns)"></i></span></li>
              <li><span class="label">对应幅度</span><span class="num">{{yuanYouBianHuaLv.rem}}</span></li>
              <li><span class="label">窗口期</span><span class="num">{{yuanYouBianHuaLv.ckq}}</span></li>
            </ul>
            <div style="flex:1; height:100%;">
              <ChartPie :options="yuanYouBianHuaLv" :config="{legend:false,tooltipShow:false}"></ChartPie>
            </div>
          </div>
        </div>
      </div>
      <!-- 国际原油与国内成品油价格走势图 -->
      <div style="flex:3; display:flex; flex-direction:column;">
        <h3 class="title">国际原油与国内成品油价格走势图</h3>
        <div class="chart-box" style="flex:1;">
          <chartTwo :options="yuanYou" :config="{yName:[{unit:'元/吨'},{unit:'美元/桶'}] , legend:true}" ></chartTwo>
        </div>
      </div>
      <!-- 山东地炼估价-汽油 -->
      <div class=" shandong" style="flex:3;">
        <h3 class="title">山东地炼估价</h3>
        <div class="content-wrap chart-box" :class="{'show':show==0}">
          <chartLine :options="shanDongChaiYou" :config="{unit:'元/吨'}"></chartLine>
        </div>
        <div class="content-wrap chart-box" :class="{'show':show==1}">
          <chartLine :options="shanDongQiYou" :config="{unit:'元/吨'}"></chartLine>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- main-content -->
    <div class="main-content">
      <div class="jc-count" id="jcCount">
        <div class="box" :class="comClass(index)" v-for="(item,index) in zhiBiaoKa" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="text">
            <strong>{{ item.value }}</strong>
            <span :class="comZhangDie(item)">
              <i class="icon"></i>
              <em>{{item.floatValue}}</em>
              <em style="margin-left:.1rem;">{{item.floatRate}}%</em>
            </span>
          </div>
        </div>
      </div>
      <!-- map -->
      <div class="chart-box map-chart">
        <div class="legends">
          <span class="chaiyou">柴油(元/吨)</span>
          <span class="qiyou">汽油(元/吨)</span>
        </div>
        <ChartMap :options="mapData"></ChartMap>
      </div>
      <div class="wrapper">
        <div class="item">
          <h3 class="title">汽油表观消费量</h3>
          <div class="chart-box">
            <chartLine :options="qiYouBiaoGuanXiaoFeiLiang"  :config="{unit:'万吨'}"></chartLine>
          </div>
        </div>
        <div class="item">
          <h3 class="title">柴油表观消费量</h3>
          <div class="chart-box">
            <chartLine :options="chaiYouBiaoGuanXiaoFeiLiang"  :config="{unit:'万吨'}"></chartLine>
          </div>
        </div>
      </div>
    </div>
    <!-- main-right -->
    <div class="main-right">
      <!-- 中国炼油能力 -->
      <div class="chart-box">
        <h3 class="title">中国炼油能力</h3>
        <chartLine :options="lianYouNengLi"  :config="{unit:'万吨/年'}"></chartLine>
      </div>
      <!-- 2022中国地方炼油能力占比 -->
      <div class="chart-box port-chart">
        <h3 class="title">中国炼能权重占比</h3>
        <ChartPie :options="diFangLianYou" :config="{legend:false,tooltipShow:true}"></ChartPie>
      </div>
      <!-- 汽油产量 -->
      <div class="chart-box shandong capacity-chart">
        <h3 class="title">产量</h3>
        <div class="content-wrap" :class="{'show':show==0}">
          <chartLine ref="cy" :options="chaiYouChanLg" :config="{unit:'万吨/月'}"></chartLine>
        </div>
        <div class="content-wrap" :class="{'show':show==1}">
          <chartLine ref="qy" :options="qiYouChanLg" :config="{unit:'万吨/月'}"></chartLine>
        </div>
      </div>
      <!-- 成品油出口量 -->
      <div class="chart-box">
        <h3 class="title">成品油出口量</h3>
        <div class="shandong">
          <div class="jc-export content-wrap" style="align-iitems:center;" :class="{'show':show==0}" v-for="(item,index) in exportData" :key="index">
            <div class="text" style="align-items:center;">
              <ul class="ulist" style="flex:1; padding:0 .05rem;">
                <li><span class="label">{{parseInt(item.options.x[item.options.x.length-1].split('-')[1])}}月{{ item.title.includes('汽油')?"汽油":"柴油" }}出口</span><span class="num">{{ item.monthValue }}{{ item.unit }}</span></li>
                <li><span class="label">上月{{ item.title.includes('汽油')?"汽油":"柴油" }}出口</span><span class="num">{{item.lastMonthValue}}{{item.unit}}<i class="icon" :class="computedZd(item)"></i></span></li>
                <li><span class="label">月环比</span><span class="num">{{item.monthOnMonth}}<i>%</i><i class="icon" :class="computedZd(item)"></i></span></li>
              </ul>
            </div>
            <div class="chart-box">
              <chartLine :options="item.options"  :config="{unit:'万吨'}"></chartLine>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import chartTwo from "@/components/chart/two.vue";
import ChartLine from "@/components/chart/line.vue";
import ChartMap from "@/components/chart/chart-map.vue";
import ChartPie from "@/components/chart/pie.vue";
export default {
  name: 'Home',
  components: {
    chartTwo,
    ChartLine,
    ChartMap,
    ChartPie
  },
  computed:{
    comClass(){
      return (index)=>{
        return 'box'+(index+1)
      }
    },
    comZhangDie(){
      return (item)=>{
        var zd = '';
        if(item.floatValue > 0){
          zd = 'up'
        }else if(item.floatValue < 0){
          zd = 'down'
        }else{
          zd = 'num'
        }
        return zd;
      }
    },
    computedZd(){
      return (item)=>{
        var zd = '';
        if(item.monthOnMonth > 0){
          zd = 'up'
        }else if(item.monthOnMonth < 0){
          zd = 'down'
        }else{
          zd = 'none'
        }
        return zd
      }
    },
    comZd(){
      return (item)=>{
        var zd = '';
        if(item > 0){
          zd = 'up'
        }else if(item < 0){
          zd = 'down'
        }else{
          zd = 'none'
        }
        return zd
      }
    }
  },
  data(){
    return {
      show:0,
      zhiBiaoKa:[],
      yuanYou:{
        x:[],
        series:[]
      },
      shanDongQiYou:{
        x:[],
        series:[]
      },
      shanDongChaiYou:{
        x:[],
        series:[]
      },
      lianYouNengLi:{
        x:[],
        series:[]
      },
      mapData:{
        series:[]
      },
      qiYouChanLg:{
        x:[],
        series:[]
      },
      chaiYouChanLg:{
        x:[],
        series:[]
      },
      YYBHLPrice:[],
      yuanYouBianHuaLv:{},
      exportData:[],
      qiYouBiaoGuanXiaoFeiLiang:{
        x:[],
        series:[]
      },
      chaiYouBiaoGuanXiaoFeiLiang:{
        x:[],
        series:[]
      },
      diFangLianYou:{
        series:[]
      }
    }
  },
  created(){
    // 原油成品油
    this.getYuanYouCpyData()
    // 山东地炼
    this.getShanDongData()
    // 中国炼油能力
    this.getLianYouNengLiData()
    // 中间的数值指标卡
    this.getZhiBiaoKaData()
    // 地图
    this.getMapData()
    // 汽油产量
    this.getQiYouChanLiangData()
    // 原油变化率
    this.getYuanYouBianHuaLvData();
    // 出口量
    this.getChuKouLiangData();
    // 汽油表观消费量
    this.getQiYouBiaoGuanData();
    // 柴油表观消费量
    this.getChaiYouBiaoGuanData();
    // 中国地方炼油能力占比
    this.getDiFangLianYouData();
  },
  mounted(){
    this.setIntervalFn();
  },
  methods:{
    setIntervalFn(){
      setInterval(()=>{
        this.show++
        this.show = this.show%2;
      },3000)
    },
    async getYuanYouCpyData(){
      let res = await this.$http.getYuanYouCpy();
      // console.log(res,'---原油成品油')
      if (res.code === 200) {
        this.yuanYou.x = res.data.x.map(item=>item.slice(2));
        this.yuanYou.series = res.data.y.map(item=>{
          if(item.name==='WTI'){
            return {
              type:'line',
              name:item.name,
              connectNulls: true,
              showSymbol: false,
              symbol: "rect",
              symbolSize: 1,
              symbolRotate: 45,
              yAxisIndex:1,
              data:item.value
            }
          }else{
            return {
              type:'line',
              name:item.name,
              connectNulls: true,
              showSymbol: false,
              symbol: "rect",
              symbolSize: 1,
              symbolRotate: 45,
              data:item.value
            }
          }
        })
      }else{
        console.log("原油成品油数据获取失败");
      }
    },
    async getShanDongData(){
      let res = await this.$http.getShanDong();
      // console.log(res,'---山东')
      if (res.code === 200) {
        this.shanDongQiYou.x = res.data.x.map(item=>item.slice(2));
        this.shanDongQiYou.series = res.data.y.filter(item=>item.name==='汽油').map(item=>{
          return {
            type:'line',
            name:item.name,
            connectNulls: true,
            showSymbol: false,
            symbol: "rect",
            symbolSize: 1,
            symbolRotate: 45,
            data:item.value
          }
        })
        
        this.shanDongChaiYou.x = res.data.x.map(item=>item.slice(2));
        this.shanDongChaiYou.series = res.data.y.filter(item=>item.name==='柴油').map(item=>{
          return {
            type:'line',
            name:item.name,
            connectNulls: true,
            showSymbol: false,
            symbol: "rect",
            symbolSize: 1,
            symbolRotate: 45,
            data:item.value
          }
        })
      }else{
        console.log("今日聚焦数据获取失败");
      }
    },
    
    async getLianYouNengLiData(){
      let res = await this.$http.getLianYouNengLi();
      console.log(res,'---中国炼油能力')
      if (res.code === 200) {
        this.lianYouNengLi.x = res.data.x;
        this.lianYouNengLi.series = [{
          type:'bar',
          name:res.data.title,
          data:res.data.y
        }]
      }else{
        console.log("中国炼油能力数据获取失败");
      }
    },

    async getZhiBiaoKaData(){
      let res = await this.$http.getZhiBiaoKa();
      // console.log(res,'---中间的数值指标卡')
      if (res.code === 200) {
        this.zhiBiaoKa = res.data
      }else{
        console.log("中间的数值指标卡数据获取失败");
      }
    },
    
    async getMapData(){
      let res = await this.$http.getMap();
      // console.log(res,'-----地图')
      if (res.code === 200) {
        /* this.mapData.series = res.data.map(item=>{
          return {
            name:item.province,
            city:item.city,
            cyPrice:item.cyPrice.cyPrice,
            qyPrice:item.qyPrice.qyPrice,
          }
        }) */
        let i=0;
        this.mapData.series = res.data.map(item=>{
          return {
            name:item.province,
            city:item.city,
            price:item.cyPrice.cyPrice,
            title:'柴油'
          }
        })
        setInterval(()=>{
          i++;
          if(i%2===1){
            this.mapData.series = res.data.map(item=>{
              return {
                name:item.province,
                city:item.city,
                price:item.qyPrice.qyPrice,
                title:'汽油'
              }
            })
          }else{
            this.mapData.series = res.data.map(item=>{
              return {
                name:item.province,
                city:item.city,
                price:item.cyPrice.cyPrice,
                title:'柴油'
              }
            })
          }
        },3000)
        
      }else{
        console.log("地图数据获取失败");
      }
    },
    
    async getQiYouChanLiangData(){
      let res = await this.$http.getChanLiang();
      // console.log(res,'----产量')
      if (res.code === 200) {
        this.qiYouChanLg.x = res.data.x;
        this.qiYouChanLg.series = res.data.y.filter(item=>item.name==='汽油').map(item=>{
          return {
            type:'bar',
            name:item.name,
            data:item.value
          }
        })
        this.chaiYouChanLg.x = res.data.x;
        this.chaiYouChanLg.series = res.data.y.filter(item=>item.name==='柴油').map(item=>{
          return {
            type:'bar',
            name:item.name,
            data:item.value
          }
        })
      }else{
        console.log("产量数据获取失败");
      }
    },

    async getChuKouLiangData(){
      let res = await this.$http.getChukouLiang();
      // console.log(res,'----出口量')
      if (res.code === 200) {
        this.exportData = res.data
        this.exportData = this.exportData.map(item=>{
          item.options = {
            x:item.x,
            series:[{
              type:'line',
              name:item.title,
              connectNulls: true,
              showSymbol: false,
              symbol: "rect",
              symbolSize: 1,
              symbolRotate: 45,
              data:item.y
            }]
          }
          return item
        })
        console.log(this.exportData)
      }else{
        console.log("出口量数据获取失败");
      }
    },
    async getYuanYouBianHuaLvData(){
      let res = await this.$http.getYYBHL();
      // console.log(res,'----原油变化率')
      if (res.code === 200) {
        this.YYBHLPrice = res.data.price;
        this.yuanYouBianHuaLv = res.data.yybhl;
        let gzr = res.data.yybhl.gzr;
        let listIndex = -100;
        switch(gzr){
          case "第一个":
            listIndex = 0;
          break;
          case "第二个":
            listIndex = 1;
          break;
          case "第三个":
            listIndex = 2;
          break;
          case "第四个":
            listIndex = 3;
          break;
          case "第五个":
            listIndex = 4;
          break;
          case "第六个":
            listIndex = 5;
          break;
          case "第七个":
            listIndex = 6;
          break;
          case "第八个":
            listIndex = 7;
          break;
          case "第九个":
            listIndex = 8;
          break;
          case "第十个":
            listIndex = 9;
          break;
        }
        let list = [];
        for(let i=0;i<11;i++){
          list.push({name:'',value:1})
        }
        list[list.length-1].value = 0;
        let sum = 0;
        list.map((item) => {
            sum += parseInt(item.value)
        })

        list[listIndex].name = gzr+'工作日';
        /* list[listIndex].labelLine = {
            normal: {
                show: true,
            },
          }, */

        list[list.length - 1].value = sum;
        list[list.length - 1].itemStyle ={
            color:'transparent'
        }
        list[list.length - 1].label ={
            show:false
        }
        list.forEach((item,index)=>{
          if(index<listIndex){
            item.itemStyle = {
              color:'#5c5c6d'
            }
          }else if(index==listIndex){
            item.itemStyle = {
              color:'#e42e23'
            }
          }else if(index==list.length-1) {
            item.itemStyle = {
              color:'transparent'
            }
          }else{
            item.itemStyle = {
              color:'#7b7ac7'
            }
          }
        })
        this.yuanYouBianHuaLv.series = [{
          type: "pie",
          hoverAnimation: false,
          startAngle: -180,
          radius: ["60%", "80%"],
          center: ["50%", "70%"],
          label: {
              normal: {
                  show: true,
                  position: "center", //显示在扇形上
                  formatter: "{b}", //显示内容
                  textStyle: {
                      color: "#fff", // 改变标示文字的颜色
                  },
                  // padding:[130,-135,20,-135]
              },
          },
          labelLine: {
            normal: {
                show: false,
            },
          },
          data: list,
          itemStyle: {
              borderRadius: 10,
              borderColor: 'transparent',
              borderWidth: 5,
          },
        }]
      }else{
        console.log("原油变化率数据获取失败");
      }
    },

    async getQiYouBiaoGuanData(){
      let res = await this.$http.getQiYouBiaoGuan();
      // console.log(res,'----汽油表观消费量')
      if (res.code === 200) {
        res.data.sort(function(a,b){
          return b.y.length-a.y.length;
        })
        this.qiYouBiaoGuanXiaoFeiLiang.x = res.data[0].x;
        this.qiYouBiaoGuanXiaoFeiLiang.series = res.data.map(item=>{
          return {
              type:'line',
              name:item.name,
              connectNulls: true,
              showSymbol: false,
              symbol: "rect",
              symbolSize: 1,
              symbolRotate: 45,
              areaStyle:{},
              data:item.y
            }
        })
        // console.log(this.qiYouBiaoGuanXiaoFeiLiang,'-------------------------')
      }else{
        console.log("汽油表观消费量数据获取失败");
      }
    },
    
    async getChaiYouBiaoGuanData(){
      let res = await this.$http.getChaiYouBiaoGuan();
      // console.log(res,'----柴油表观消费量')
      if (res.code === 200) {
        res.data.sort(function(a,b){
          return b.y.length-a.y.length;
        })
        this.chaiYouBiaoGuanXiaoFeiLiang.x = res.data[0].x;
        this.chaiYouBiaoGuanXiaoFeiLiang.series = res.data.map(item=>{
          return {
              type:'line',
              name:item.name,
              connectNulls: true,
              showSymbol: false,
              symbol: "rect",
              symbolSize: 1,
              symbolRotate: 45,
              areaStyle:{},
              data:item.y
            }
        })
        // console.log(this.qiYouBiaoGuanXiaoFeiLiang,'-------------------------')
      }else{
        console.log("柴油表观消费量数据获取失败");
      }
    },

    async getDiFangLianYouData(){
      // let res = await this.$http.getDiFangLianYouGuan();
      // console.log(res,'----2022年中国地方炼油能力占比')
      // if (res.code === 200) {
        // console.log(res.data)
        
        this.diFangLianYou.series = [{
          type:'pie',
          data:[
            {name: "中石化",value: 32},
            {name: "中石油",value: 25},
            {name: "中化",value: 2},
            {name: "中海油",value: 5},
            {name: "传统地炼",value: 28},
            {name: "民营炼化",value: 8}
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          },
          label: {
            show: true,
            formatter:'{b}:{d}%'
          },
        }]
        // console.log(this.diFangLianYou,'-------------------------')
      // }else{
        // console.log("2022年中国地方炼油能力占比数据获取失败");
      // }
    },
  }
}
</script>

<style lang="scss">
.shandong{
  position: relative;
  height: 100%;
  .content-wrap{
    position: absolute;
    width: 100%;
    height: calc(100% - 0.3rem);
    left:0;
    background: rgb(24, 26, 65);
  }
  .content-wrap:nth-of-type(1){
    z-index: 1;
  }
  .content-wrap:nth-of-type(2){
    z-index: 0;
  }
  .show{
    z-index: 2!important;
  }
}
.map-chart{
  position: relative;
  .legends{
    position: absolute;
    left:.6rem;
    bottom:.8rem;
    font-size: .12rem;
    display: flex;
    z-index: 9;
    .qiyou{
      color:#fb6e6c;
      position: relative;
      &::before{
        position: absolute;
        content:'';
        width: .1rem;
        height: .04rem;
        background: #fb6e6c;
        left:-.12rem;
        top:50%;
      }
    }
    .chaiyou{
      margin-right: .3rem;
      color:#86e5f8;
      &::before{
        position: absolute;
        content:'';
        width: .1rem;
        height: .04rem;
        background: #86e5f8;
        left:-.12rem;
        top:50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
